CompilerSettings
	serializeInternal	= false
	serializeExternal	= false
	stateVariables	= true

Config
	Field[]	fields

// Common styles used throughout the app. If a style is used in multiple places, define it here.
global style
	global Color	primaryColor	= Color.hsl(34, 94.80%, 54.90%)
	global Color	secondaryColor	= #0098da
	global Color	lightColor	= Color.hsl(34, 95%, 95%)
	global Color	lightGray	= Color.hsl(0, 0%, 50%)
	global Color	veryLightGray	= Color.hsl(0, 0.00%, 94.90%)
	global Color 	okColor	= #16C66E
	global Color	failedColor	= #C01352

	const Dimension	boxBorderRadius = 20px
	const BoxShadow	boxShadow = {offset:{10,10}, blur:40, spread:0, color:#d0d0d0}
	const Dimension	gapBetweenBoxes = 24px

struct float
	private const NumberFormat	currency = {"de-DE", {style:currency, currency:"EUR", maximumFractionDigits:0}}
	inline string	currencyString := currency.format(this)

	private const NumberFormat	currencyWithCents = {"de-DE", {style:currency, currency:"EUR", maximumFractionDigits:2}}
	inline string	currencyWithCentsString := currencyWithCents.format(this)

	private const NumberFormat	pecentage = {"de-DE", {maximumFractionDigits:2}}
	inline string	percentageString := pecentage.format(this * 100) + " %"

app
	const bool	loacalData	= true
	const Page[]	pagesInHeader	= [buyPage, myPage, contactPage, userPage, goodsPage]
	const int	minimumBidIncrease	= 100
	const float	commissionRate	= 0.0175
	const string	titleSuffix	= " - 123womo"

	bool	showNotifications	= false
	bool	showCookieBanner	= false
	const string	cookieBannerKey	= "cookieAccepted"
	string	selectedColor	= ""
	string	selectedColor2	= ""
	Config	config

	Page	currentPage = null
	string	currentPageParameter = ""

	User	user = null
	bool	pendingAuth = true
	float	serverTimeOffset = 0

	// Database tables
	DatabaseTable<Good>	goods	= {name:"goods"}
	DatabaseTable<Action>	actions	= {name:"actions"}
	DatabaseTable<Message>	messages	= {name:"messages"}

	// Texts & Fields
	Field[]	fields
	Text[]	texts
	string	language	= "german"

	string[GoodState]	goodStateNames = {
		Guest:	"Entwurf",
		Draft:	"Entwurf",
		Review:	"Wird geprüft",
		Auction:	"Auktion läuft",
		Negotiation:	"Nachverhandlung",
		NotSold:	"Nicht verkauft",
		Sold:	"Verkauft"
	}

	string[UserType]	userTypeNames = {
		PrivateSeller:	"Privater Verkäufer",
		BusinessSeller:	"Gewerblicher Verkäufer",
		Business:	"Händler",
		Admin:	"Administrator"
	}

	const string[ActionType] actionTypeNames = {
		ViewAuction:	"Auktion angesehen",
		ViewBuyPage:	"Übersicht angesehen",
		DirectBid:	"Direktes Gebot",
		SetAgentLimit:	"Limit für Bietagenten",
		AutomaticBid:	"Gebot des Bietagenten",
		AcceptOffer:	"Angebot angenommen",
		DenyOffer:	"Angebot abgelehnt",
		CounterOffer:	"Gegenangebot abgegeben",
		PickUp:	"Abholung bestätigt",
		RequestToCancel:	"Storno angefragt",
		AuctionEndedWithoutBid:	"Auktion ohne Gebot beendet",
		AuctionEndedBelowAskingPrice:	"Auktion unter Preisvorstellung beendet",
		AuctionEndedWithSale:	"Auktion mit Verkauf beendet",
		NegotiationEndedWithoutSale:	"Nachverhandlung ohne Verkauf beendet",
		Due:	"Fälligkeit erreicht"
	}


	init
		Platform.ticksPerSecond = 1
	
	start
		let password = Platform.getLocalStorageString "password
		if password != "sync" then
			password = System.prompt "Enter password"
			Platform.setLocalStorageString "password", password
		if password != "sync" then
			Platform.redirect "https://www.google.com"
			return

		Time.printTimer "App started"
		pendingAuth = true

		if loacalData
			texts = object.fromTypedTsv data.texts
			fields = object.fromTypedTsv data.fields
		else
			texts = await backend.fetchAll "texts"
			fields = await backend.fetchAll "fields"
		Loca.setLanguage German
		Time.printTimer "Texts & Fields"

		// Cookie banner
		showCookieBanner = !Platform.isDebug and Platform.getLocalStorageString(cookieBannerKey) != ""

		Platform.onPopState app.onPopState
		setPageFromUrl
		Time.printTimer "setPageFromUrl"

		if currentPage.needsAuth
			await auth
			if not user
				Platform.replaceState "#login"
				currentPage = loginPage				
			
		await currentPage.show(currentPageParameter)
		Time.printTimer "currentPage.show"

		refresh
		Time.printTimer "First refresh"

		delay 50 milliseconds
			Time.printTimer "delay"

			if not currentPage.needsAuth
				await auth
				refresh
				Time.printTimer "Second refresh"

			await confirmVerificationFromUrl
			await syncServerTime
			Time.printTimer "syncServerTime"

			// if not Platform.isDebug then alert(Time.timerLogs)

	auth
		// Backend
		await backend.connect
		backend.onDataChange = () => html.refresh()
		backend.autoCancellation false
		Time.printTimer "backend.connect"

		// User
		user = await backend.getAuthenticatedUser
		pendingAuth = false
		Time.printTimer "getAuthenticatedUser"
		
		onLogin
		Time.printTimer "onLogin"

		
	tick
		currentPage?.tick

	onLogin
		messages.unsubscribe
		if not user then return
		await messages.subscribe "user='{user.id}'"
			messages.items.orderBy.created
			if user and user.userType != Business and messages.items.any.kind == BusinessAccountAccepted
				user = await backend.getAuthenticatedUser
				refresh
			if currentPage == auctionPage
				auctionPage.onMessagesChanged

	async syncServerTime
		// Do 3 NTP measurements and use the one with lowest RTT for best accuracy
		try
			float bestOffset = 0
			float lowestRTT = float.maxValue
			for 3
				float t0 = Time.now
				let response = await http.get "{backend.url}/api/time"
				float t3 = Time.now
				float rtt = t3 - t0
				float offset = response.time - (t0 + t3) / 2
				if rtt < lowestRTT
					lowestRTT = rtt
					bestOffset = offset
			serverTimeOffset = bestOffset
		catch as error
			serverTimeOffset = 0

	bool isLoggedIn := user && user.id

	logout
		backend.logout
		user = null
		homePage.good = createDefaultGood Guest
		navigateTo homePage	

	Good createDefaultGood: GoodState state = Guest
		return {
			Typ: "Wohnmobil"
			state: state
			seller:user?.id
			readyForPickupTime: TimeString.now
			Umsatzsteuer: user?.userType == PrivateSeller ? "nicht umsatzsteuerpflichtig" :"inkl. 19% Umsatzsteuer"
			PLZ: user?.zipCode
			Ort: user?.city
			Land: user?.country
			bids: []
		}

	onPopState
		setPageFromUrl	
		await currentPage.show(currentPageParameter)
		refresh

	private async confirmVerificationFromUrl
		let index = Platform.url.indexOf("#confirm-verification/")
		if index == -1 then return
		let token = Platform.url.substring(index + 22)
		if not token then return
		try
			await backend.confirmVerification(token)
			alert stripHtmlTags(getText("emailConfirmed"))
			if user then navigateTo accountPage
		catch as error
			print type:Error "Error confirming email verification:", error

	js string stripHtmlTags: string html
		let node = new DOMParser().parseFromString(html, 'text/html')
		return node.body.textContent

	private setPageFromUrl
		dynamic page = homePage
		let slashIndex = Platform.locationHash.indexOf("/")
		if slashIndex == -1 then slashIndex = Platform.locationHash.length
		let firstSegment = Platform.locationHash[1..slashIndex]
			page = globals[firstSegment+"Page"]
			if not page and texts.find.kind == firstSegment+"Page" then page = staticPage
		if !page?.show then page = homePage
		currentPage?.hide
		currentPage = page
		currentPageParameter = Platform.locationHash[slashIndex+1..]

	navigateTo: Page page, string id = ""
		Platform.pushState "#{page.type.toString[..-4].toLowerCase}/{id}"
		currentPage?.hide
		currentPage = page
		await page.show id
		refresh
		html.scrollToTop


	string getText: string kind
		let text = texts.find.kind == kind
		return text ? text[language+"Text"] : ""

	draw
		// html.style "* \{ user-select: none; -webkit-user-select: none; \}"
		html.style "h1" color:secondaryColor margin:{top:0 bottom:.4em}
		html.style "h2" color:secondaryColor margin:{top:0 bottom:.4em}
		html.style "p" margin:{bottom:.8em}
		html.style "details", "background: #ffffff; border: 1px solid #e5e7eb; border-radius: 16px; padding: 18px 22px; margin-bottom: 16px; box-shadow: 0 10px 24px rgba(0,0,0,0.04);"
		html.style "summary", "cursor: pointer; font-size: 18px; font-weight: 600; color: #111827; list-style: none;"
		html.style "summary::-webkit-details-marker", "display: none;"
		html.style "details[open] summary:after", "content: '-'; float: right; font-size: 18px; font-weight: 400; color:"+primaryColor+";"
		html.style "details summary:after", "content: '+'; float: right; font-size: 18px; font-weight: 400; color:" +primaryColor+";"
		html.style "details p", "margin-top: 12px; margin-bottom: 0; color: #4b5563; line-height: 1.5;"
		
		// Disable zoom on mobile devices
		html.style "html, body", "touch-action: pan-x pan-y;"
		html.style "input, textarea, select", "font-size: 16px;"
		
		if currentPage
			div maxWidth:960px, margin:{leftAndRight:auto} padding:{left:20px right:20px}
				if currentPage.hasHeaderAndFooter then drawHeader
				currentPage.draw
				if currentPage.hasHeaderAndFooter then drawFooter
		if showCookieBanner then drawCookieBanner

	drawHeader
		div borderBottom:{width:1px, style:solid, color:#e5e9f2}, width:100%
			div width:100%, padding:{top:20 bottom:20}, display:flex, alignItems:center, justifyContent:spaceBetween
				img Logo, width:200, cursor:pointer, onClick:navigateTo homePage
				if pendingAuth then return
				let pagesToShow = pagesInHeader.where not .showFor or (user and user and .showFor.contains(user.userType))
				let showMenuAsDropdown = isMobile and user
				contactPage.title = pagesToShow.length <= 1 and not isMobile ? "Fragen? Wir sind für Sie da!" : "Kontakt"
				if not showMenuAsDropdown
					div display:flex, gap:28, fontSize:16, color:#40465a, fontWeight:bold
						for pagesToShow as page
							div text:page.title, color:currentPage == page ? primaryColor : #40465a, cursor:pointer
								onClick:navigateTo page
				div display:flex, alignItems:center, gap:isMobile ? 32 : 20, position:relative
					if not user
						app.button text:"Anmelden", onClick:navigateTo loginPage
					else
						drawNotifications
						dropdownMenu AccountIcon
							div "Mein Konto", padding:{all:16}, cursor:pointer, onClick:navigateTo accountPage, borderBottom:{width:1px, style:solid, color:#e5e9f2}
							div "Abmelden", padding:{all:16}, cursor:pointer, onClick:logout
					if showMenuAsDropdown
						dropdownMenu MenuIcon
							for pagesToShow as page
								div text:page.title, padding:{all:16}, color:currentPage == page ? primaryColor : #40465a, cursor:pointer
									borderBottom:{width:1px, style:solid, color:i < pagesToShow.length - 1 ? #e5e9f2 : transparent}
									onClick:
										navigateTo page

	drawFooter
		row alignItems:center justifyContent:center margin:{top:40 bottom:100} gap:16
			html.link "Impressum" to "/#imprint"
			html.link "Datenschutz" to "/#privacy"
			html.link "AGB" to "/#agb"

	drawNotifications
		let unreadMessages = messages.where.read == false
		let unreadCount = unreadMessages.length

		// Bell icon with badge
		div cursor:pointer, onClick:showNotifications = !showNotifications; refresh
			div position:relative, display:inlineBlock
				img NotificationIcon, height:32, marginTop:8
				if unreadCount > 0
					div position:absolute, top:-6, right:-8, backgroundColor:#e53935, color:white, fontSize:11, fontWeight:bold
						minWidth:18, height:18, borderRadius:9, display:flex, alignItems:center, justifyContent:center
						text:unreadCount > 99 ? "99+" : "{unreadCount}"
		
		if showNotifications
			// Close popup when clicking outside
			div position:fixed, top:0, left:0, right:0, bottom:0, zIndex:999, onClick:showNotifications = false; refresh

			// Dropdown content
			div position:absolute, right:0, top:52, zIndex:1000, width:360, maxHeight:600, overflowY:auto
				backgroundColor:white, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, border:{1px solid #e5e9f2}
				if messages.length == 0
					div text:"Keine Benachrichtigungen", padding:{top:24 bottom:24 left:16 right:16}, color:lightGray, textAlign:center
				else
					div padding:{top:12 bottom:12 left:16 right:16}, borderBottom:{1px solid #e5e9f2}
						div text:"Benachrichtigungen", fontSize:16, fontWeight:bold, color:#2b3145
					for messages backwards as message
						drawNotificationItem message

	drawNotificationItem: Message message
		row padding:{top:12 bottom:12 left:16 right:16}, cursor:pointer
			backgroundColor:message.read ? white : style.lightColor
			borderBottom:{1px solid #e5e9f2}, gap:12
			onClick:
				showNotifications = false
				if message.good then	navigateTo auctionPage, message.good
				else	refresh
				if not message.read then await messages.update message, {read:true}
					
			// Unread indicator
			div width:8, height:8, borderRadius:4, marginTop:6, flexShrink:0
				backgroundColor:message.read ? transparent : primaryColor

			if message.imageUrl
				img src:"{backend.url}{message.imageUrl}", width:48, height:48, objectFit:cover, borderRadius:8, flexShrink:0

			column gap:4
				if message.goodName then	div text:message.goodName, fontSize:12
				if message.subject then	div text:message.subject, fontSize:15, fontWeight:bold, color:secondaryColor
				// if message.price: div text:message.price.currencyString, fontSize:28, fontWeight:bold, color:secondaryColor
				div text:message.text, fontSize:14, color:#2b3145
				div text:"{message.created.dayShortMonthNameString} {message.created.hourMinuteString} Uhr", fontSize:12, color:lightGray

	drawCookieBanner
		div position:fixed, left:0, right:0, bottom:0, zIndex:999
			backgroundColor:#f0f0f0	, color:#2b3145, fontSize:12, padding:{top:24 bottom:24 left:24 right:24}
			display:flex, alignItems:center, gap:12
			div getText("cookieBanner")
			let button = html.get("acceptCookiesButton")
			if(button) button.onclick = app.clickCookieBanner
	
	clickCookieBanner
		Platform.setLocalStorageString cookieBannerKey, "true"
		showCookieBanner = false
		refresh

	box: Dimension width = 100%, void() children
		div width, backgroundColor:white, borderRadius:style.boxBorderRadius, padding:{top:32 bottom:32 left:32 right:32}, boxShadow:style.boxShadow
			children

	button: string text, void() onClick = null, bool isDisabled = false, bool triggerWithEnterKey = false, Dimension width = auto, Dimension height = auto, Padding padding = {top:12 bottom:12 left:32 right:32}
		html.button text:text, fontSize:16, padding, triggerWithEnterKey:triggerWithEnterKey
			borderRadius:8, border:{2px solid isDisabled ? #d1d5db : transparent}, backgroundColor:isDisabled ? white : primaryColor
			color:isDisabled ? #9aa2b1 : white, cursor:isDisabled ? default : pointer, onClick:if(!isDisabled) onClick()
			width, height

	dropdownMenu: Image iconImage, Dimension height = 32px, void() content
		state bool showMenu = false
		// Icon
		img iconImage, height, cursor:pointer, onClick:showMenu = !showMenu; refresh

		if showMenu
			// Close menu when clicking outside
			div position:fixed, top:0, left:0, right:0, bottom:0, zIndex:999, onClick: showMenu = false; refresh
			
			// Menu content
			div position:absolute, right:0, top:52, zIndex:1000, width:230
				backgroundColor:white, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, border:{1px solid #e5e9f2}, overflow:hidden
				onClick:showMenu = false; refresh
				content()

	drawTags: Good item
		div display:flex, flexWrap:wrap, gap:10
			if item.Jahr_der_Erstzulassung	drawTag "Erstzulassung: {item.Jahr_der_Erstzulassung}"
			if item.Kilometerstand	drawTag "{item.Kilometerstand} km"
			if item.Motorleistung_in_kW	drawTag "{item.Motorleistung_in_kW} kW"
			if item.Getriebe	drawTag item.Getriebe
			if item.Fahrgestell	drawTag item.Fahrgestell
			if item.Anzahl_der_Schlafplaetze	drawTag "{item.Anzahl_der_Schlafplaetze} Schlafplätze"
			if item.Ort	drawTag "Standort: {item.Ort}"

	drawTag: string text
		div text:text, fontSize:13, color:#465068, backgroundColor:#edf1f7, padding:{top:6 bottom:6 left:10 right:10}, borderRadius:14

	const Color[MessageCategory] categoryBackgroundColor = {Ok:style.okColor, Failed:style.failedColor, ActionRequired:style.primaryColor}		
	drawGoodState: Good good, bool isAdminPage = false
		string text
		Color backgroundColor
		if not isAdminPage
			let msg = app.messages.items.findLast.good == good.id
				if msg.context != "Prepare"
					text = msg.subject
					backgroundColor = categoryBackgroundColor[msg.category]
		else
			text = goodStateNames[good.state]
			backgroundColor = good.state == Sold ? style.okColor : good.state == NotSold ? style.failedColor : style.primaryColor

		if text
			div text:text, fontSize:13, color:white, backgroundColor:backgroundColor, 
				padding:{top:6 bottom:6 left:10 right:10}, marginBottom:8, borderRadius:8

	drawGoodBox: Good good, bool isAdminPage = false
		column backgroundColor:#ffffff, borderRadius:20, padding:{top:24 bottom:24 left:24 right:24}, boxShadow:{offset:{0,10}, blur:30, spread:0, color:#dfe4ef}, cursor:pointer, gap:4
			drawGoodState good, isAdminPage
			grid gridTemplate:"'title title' 'img body' 0fr 'img price' 1fr 'tags tags' / 2fr 3fr" gap:12
				div gridArea:"title" "{good.Marke} {good.Modell}" fontSize:25, color:#2b3145
				
				div gridArea:"img" minWidth:0
					if good.Bilder and good.Bilder.length > 0
						img "{backend.url}/api/files/goods/{good.id}/{good.Bilder[0]}", width:100%, borderRadius:18
					else
						img Placeholder, width:100%, borderRadius:18

				div gridArea:"body"
					drawCountdown good

				row gridArea:"price" gap:32
					if app.user?.canSeeAuction
						drawPrice "Aktueller Preis", good.currentPrice.currencyString or "Kein Gebot", good.Umsatzsteuer
					drawPrice "Preisvorstellung", good.Preisvorstellung ? good.Preisvorstellung.currencyString : "Keine Preisvorstellung", good.Umsatzsteuer

				div gridArea:"tags"
					app.drawTags good

		onClick:
			if good.seller == user.id and (good.state == Guest or good.state == Draft)
				app.navigateTo editPage, good.id
			else
				app.navigateTo auctionPage, good.id
			

	drawPrice: string label, string value, string sublabel
		div display:flex, flexDirection:column
			div text:label, fontSize:14, color:#7a8195
			div text:value, fontSize:22, fontWeight:bold, color:secondaryColor
			// if sublabel != "": div text:sublabel, fontSize:13, color:#9aa2b1

	drawCountdown: Good good
		bool isNegotiation = good.state == Negotiation
		TimeString endTimeText = isNegotiation ? good.negotiationEndTime : good.auctionEndTime
		string label = isNegotiation ? "Nachverhandlung" : "Auktion"
		if not endTimeText
			div marginTop:16
				div text:"{label}sende nicht festgelegt", fontSize:13, color:lightGray
			return
		// Calculate remaining time using server time offset
		float serverTime = Time.now + app.serverTimeOffset
		float endTime = Date(endTimeText).time
		float remaining = endTime - serverTime
		if remaining <= 0
			div text:"{label} beendet am {endTimeText.dayMonthNameYearString} um {endTimeText.hourMinuteString} Uhr", fontSize:13, color:lightGray
		else
			// Calculate days, hours, minutes, seconds
			int totalSeconds = math.ceil(remaining / 1000)
			// int days = math.floor(totalSeconds / 86400)
			int hours = math.floor(totalSeconds / 3600)
			int minutes = math.floor((totalSeconds mod 3600) / 60)
			int seconds = totalSeconds mod 60
			// Format countdown string
			string countdownText = ""
			// if days > 0: countdownText = "{days} Tag{days != 1 ? "e" : ""} "
			if hours > 0 then	countdownText = countdownText + "{hours} Stunde{hours != 1 ? "n" : ""} "
			if minutes > 0 or hours > 0 then	countdownText = countdownText + "{minutes} Minute{minutes != 1 ? "n" : ""} "
			countdownText = countdownText + "{seconds} Sekunde{seconds != 1 ? "n" : ""}"
			div
				div text:"{label} endet am {endTimeText.dayMonthNameYearString} um {endTimeText.hourMinuteString} Uhr", fontSize:13, color:lightGray
				div text:countdownText, fontSize:18, fontWeight:bold

Page
	string	title
	bool	hasHeaderAndFooter	= true
	UserType[]	showFor	= []
	bool	needsAuth	= true

	async show: string id = ""
	hide
	draw
	tick
